import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'

import atsCompanies from 'modules/ats/store/collections/atsCompanies'
import GDPRDataRetention from 'modules/ats/store/models/GDPRDataRetention'

class GDPRDataRetentions extends Collection<GDPRDataRetention> {
  constructor(data = []) {
    super(data)
    makeObservable(this, {
      current: computed,
    })
  }

  model() {
    return GDPRDataRetention
  }

  get current(): GDPRDataRetention | null | undefined {
    const id = atsCompanies.current?.attributes.id

    if (!id) return null

    return this.find({ ats_company_id: id })
  }
}

const singleton: GDPRDataRetentions = new GDPRDataRetentions()

export default singleton
